"use strict";

var _objectWithoutProperties = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var custom_modal_component_1 = __importDefault(require("../custom-modal/custom-modal.component"));

var confirmation_modal_content_component_1 = __importDefault(require("../confirmation-modal-content/confirmation-modal-content.component"));

var ConfirmationModal = function ConfirmationModal(_ref) {
  var isOpen = _ref.isOpen,
      handleClose = _ref.handleClose,
      otherProps = _objectWithoutProperties(_ref, ["isOpen", "handleClose"]);

  return React.createElement(custom_modal_component_1.default, {
    isOpen: isOpen,
    handleClose: handleClose
  }, React.createElement(confirmation_modal_content_component_1.default, Object.assign({}, otherProps)));
};

exports.default = ConfirmationModal;